// PLACEHOLDER — internal jobs-database write-back.
//
// The jobs DB (MIC) integration is delayed. Until it lands, a confirmed match
// has no system to push to, so this stub stands in for output (3): "push the
// entered material-receipt + manual job data into the internal jobs database".
//
// When the real integration arrives, replace the body with the actual API call
// (e.g. POST /api/v1/jobs/receipts). The call site in AcePage already passes the
// full payload, so only this function needs to change.

export interface JobsDbPushPayload {
  category: string;
  disposition: string;
  received: { type: string; receivedQty: number }[];
  jobs: {
    jobNumber: string;
    issuerName: string;
    eventDate?: string;
    recordDate?: string;
    effectiveDate?: string;
    materials: { type: string; orderedQty: number }[];
  }[];
}

export async function pushReceiptToJobsDb(payload: JobsDbPushPayload): Promise<{ ok: boolean; placeholder: true }> {
  // No-op placeholder. Intentionally does not hit the network.
  // eslint-disable-next-line no-console
  console.info('[jobsDbService] placeholder push (jobs DB not yet integrated):', payload);
  return { ok: true, placeholder: true };
}
